import "./App.css";
import { Form, Input, Button, Col, Row, Spin, Modal } from "antd";
import { UserOutlined, LockOutlined } from "@ant-design/icons";
import axios from "axios";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import decode from "jwt-decode";
import l1 from "./Images/measure.png";
import l2 from "./Images/plan.png";
import l3 from "./Images/iterate.png";

import agblack from "./Images/agblack.png";

const App = () => {
  const searchParams = new URLSearchParams(window.location.search);
  const [loading, setLoading] = useState(false);

  const baseUrl = process.env.REACT_APP_SSO_API.replace(/\s+/g, "");

  useEffect(() => {
    const localtoken = localStorage.getItem("token") || null;

    if (localtoken) {
      setLoading(true);
      axios
        .post(
          `${baseUrl}/check-token-exp`,
          {},
          {
            headers: {
              Authorization: localtoken,
            },
          }
        )
        .then((response) => {
          setLoading(false);
          let payload = decode(response.data.user_token);

          if (payload.exp * 1000 < new Date().getTime()) {
            window.localStorage.clear();
          } else {
            if (searchParams.get("domain")) {
              const params = new URLSearchParams(window.location.search);
              params.delete("domain");
              const newUrlString = "?" + params.toString();
              const redirectedURL = new URL(
                searchParams.get("domain") + newUrlString
              );

              redirectedURL.searchParams.delete("token");

              redirectedURL.searchParams.set("token", localtoken);

              window.location.href = redirectedURL.toString();
            } else {
              window.location.replace(localStorage.getItem("redirect_url"));
            }
          }
        })
        .catch((error) => {
          // Handle errors here

          window.localStorage.clear();
          setLoading(false);
        });
    }
  }, []);

  const onFinish = (values) => {
    setLoading(true);
    axios
      .post(
        `${baseUrl}login`,
        {
          email: values.username.toString().toLocaleLowerCase(),
          password: values.password,
          domain: window.location.search,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        const url = new URL(response.data);

        const queryString = url.search;

        const searchParams = new URLSearchParams(queryString);

        const accessToken = searchParams.get("token");

        localStorage.setItem("token", accessToken);

        localStorage.setItem("redirect_url", response.data);

        window.location.replace(response.data);
      })
      .catch((error) => {
        setLoading(false);
        warning(error.response?.data.error);
      });
  };

  const warning = (message) => {
    Modal.error({
      title: "Validation Error!",
      content: message,
    });
  };

  // Function to decode the base64 encoded payload of the JWT
  const decodeBase64 = (str) => {
    try {
      return JSON.parse(window.btoa(str));
    } catch (error) {
      // Handle error if the token is not a valid base64 encoded string
      console.error("Error decoding token:", error);
      return null;
    }
  };

  const decryptAuthParams = (str) => {
    try {
      let arr = atob(str).split("!!&!!");
      let str1 = atob(arr[0]) + atob(arr[1]);
      return str1;
    } catch (e) {
      throw new Error("Unable to decrypt the string");
    }
  };

  return (
      <Spin spinning={loading}>
        <div className="rebrand-login-main">
          <Row>
            <Col
              lg={{ span: 12 }}
              xs={{ span: 24 }}
              className="rebrand-login-left"
            >
              <h3>A holistic view of performance</h3>
              <ul>
                <li>
                  <img src={l1} alt="img" />
                  <h5>Measure</h5>
                  <p>
                    Link over 25 platforms to track performance across paid
                    search, SEO, email, SMS, social, programmatic, marketplaces
                    and more!
                  </p>
                </li>
                <li>
                  <img src={l2} alt="img" />
                  <h5>Plan</h5>
                  <p>
                    Improve your campaigns and optimize spend across channels
                    through forecasting and predictive analytics.
                  </p>
                </li>
                <li>
                  <img src={l3} alt="img" />
                  <h5>Iterate</h5>
                  <p>
                    Let past, present, and projected performance inform your
                    marketing channel spend, audience and campaign creative.{" "}
                  </p>
                </li>
              </ul>
            </Col>
            <Col
              lg={{ span: 12 }}
              xs={{ span: 24 }}
              className="rebrand-login-right"
            >
              <div className="rebrand-login-form">
                <div className="rebrand-login-right-image">
                  <img src={agblack} alt="" />
                </div>
                <Form
                  name="rebrand-login"
                  initialValues={{
                    remember: true,
                  }}
                  onFinish={onFinish}
                  layout="vertical"
                >
                  <Form.Item
                    name="username"
                    label="Email"
                    rules={[
                      {
                        required: true,
                        message: "Please input your Username!",
                      },
                    ]}
                  >
                    <Input
                      prefix={<UserOutlined className="site-form-item-icon" />}
                      placeholder="Email"
                      autoComplete="off"
                      size="large"
                    />
                  </Form.Item>
                  <Form.Item
                    name="password"
                    label="Password"
                    rules={[
                      {
                        required: true,
                        message: "Please input your Password!",
                      },
                    ]}
                  >
                    <Input.Password
                      prefix={<LockOutlined className="site-form-item-icon" />}
                      type="password"
                      placeholder="Password"
                      autoComplete="off"
                      size="large"
                    />
                  </Form.Item>

                  <Form.Item>
                    <Button
                      type="primary"
                      htmlType="submit"
                      className="rebrand-login-form-button"
                    >
                      Login
                    </Button>
                  </Form.Item>

                  <Form.Item className="rebrand-login-forgot-link">
                    <Link to="/forget-password">Forgot password?</Link>
                  </Form.Item>
                </Form>
              </div>
            </Col>
          </Row>
        </div>
      </Spin>
  );
};

export default App;
